import PageBaseButton from './PageBaseButton';

interface SearchButtonProps {
  onClick: () => void;
}

const SearchButton = ({ onClick }: SearchButtonProps) => {
  return (
    <PageBaseButton
      variant="search-custom"
      buttonText="検索"
      onClick={onClick}
    />
  );
};

export default SearchButton;
